/** The session token kept on the device — iPad Safari does not always hold the cookie. */
const KEY = "chambers-session-token";

export const getSessionToken = () => {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
};

export const setSessionToken = (token) => {
  try {
    if (token) localStorage.setItem(KEY, token);
    else localStorage.removeItem(KEY);
  } catch {
    /* private browsing — the cookie is all we have */
  }
};

export const clearSessionToken = () => setSessionToken(null);
